import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import httpClient from '../http/HttpRequest';
import { CUSTOMER_DETAILS } from '../data/url';
import { checkToken } from '../utils/Auth';

const CustomerContext = createContext();

export const useCustomerContext = () => {
    return useContext(CustomerContext);
};

export const CustomerProvider = ({ children }) => {
    const [customerData, setCustomerData] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        if (checkToken()) {
            getCustomer();
        }
    }, []);

    const getCustomer = async () => {
        try {
            const res = await httpClient.post(CUSTOMER_DETAILS, {});
            if (res.requestStatus === 'OK' && res.result.status === 1) {
                setCustomerData(res.result.data);
            } else {
                localStorage.removeItem('token'); // Remove invalid token
                navigate('/login'); // Navigate to login page if needed
            }
        } catch (error) {
            console.error('User error:', error);
        }
    };

    const updateCustomerData = async () => {
        getCustomer();
    };

    return (
        <CustomerContext.Provider value={{ customerData, updateCustomerData }}>
            {children}
        </CustomerContext.Provider>
    );
};
